import { render, staticRenderFns } from "./ChannelBindDia.vue?vue&type=template&id=514c1ca0&scoped=true"
import script from "./ChannelBindDia.vue?vue&type=script&lang=js"
export * from "./ChannelBindDia.vue?vue&type=script&lang=js"
import style0 from "./ChannelBindDia.vue?vue&type=style&index=0&id=514c1ca0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514c1ca0",
  null
  
)

export default component.exports